<ng-container *ngIf="isForm()">
  <app-progress-bar [noOfView]="noOfView" [signUpPageCount]="pageCount"></app-progress-bar>
  <app-auth-connect-header></app-auth-connect-header>
  <form #authForm="ngForm">
    <app-auth-code *ngIf="pageCount === SignupPageCount.auth_code" [userProfile]="userProfile" ></app-auth-code>
    <app-personal-info *ngIf="pageCount === SignupPageCount?.personal_info" [page]="page"
      [userProfile]="userProfile"></app-personal-info>
    <app-contact-no *ngIf="pageCount === SignupPageCount?.contact_detail" [page]="page"
      [userProfile]="userProfile"></app-contact-no>
  </form>
</ng-container>


<!-- subtenant selection -->
<div *ngIf="pageCount === SignupPageCount?.subtenant">
  <app-subtenant-selection (subtenantClick)="selectedSubtenant($event)"></app-subtenant-selection>
</div>

<!-- survey -->
<div *ngIf="pageCount === SignupPageCount?.survey">
  <app-survey [userProfile]="userProfile"></app-survey>
</div>
